import React, { Component } from "react";
// import LoginComponent from "../components/Login/index";
import Header from "../components/Header/index";
import Footer from "../components/Footer/index";
import TrackOrerComponent from "../components/TrackOrder/index";
import { Redirect } from "react-router-dom";

class TrackOrer extends Component<{ history: any,location:any }, {}> {
    componentDidMount(){
        // document.title = "Track Order - Tortilla";
        document.title = "Track Order - Kyochon"
    }
    render() {
        // if (!localStorage.mainToken) {
        //     return <Redirect to="/landing" />
        // }
        return (
            <div className="page-wrapper">
                <div id="page-wrap">
                    <Header history={this.props.history} />
                    <TrackOrerComponent location={this.props.location} />
                    <Footer />
                </div>
            </div>
        );
    }
}

export default TrackOrer;